import { Sunburst } from '@ant-design/plots';
import {
    transformDataForSunburst,
} from './skill-framework-chart-utils';
import type { SkillNode } from './skill-framework-chart-utils';

interface SkillFrameworkSunburstProps {
    framework: SkillNode;
    height?: number | string;
}

const SkillFrameworkSunburst = ({
    framework,
    height = 760,
}: SkillFrameworkSunburstProps) => {
    return (
        <div
            className="bg-slate-50 dark:bg-slate-900 rounded-lg border p-6"
            style={{ height: typeof height === 'number' ? `${height}px` : height }}
        >
            <Sunburst
                data={transformDataForSunburst(framework)}
                autoFit
                paddingTop={48}
                paddingBottom={56}
                paddingLeft={24}
                paddingRight={24}
                innerRadius={0.1}
                outerRadius={0.85}
                dataField="value"
                nameField="label"
                colorField="label"
                legend={false}
                label={false}
                tooltip={{ title: 'label', items: false }}
                interactions={[{ type: 'element-active' }]}
            />
        </div>
    );
};

export default SkillFrameworkSunburst;
